import React from "react";
import Header from "./components/header/Header";
import Main from "./components/main/Main";
import Footer from "./components/footer/Footer";

import "./App.scss";

function App() {
  return (
    <div className="app">
      <Header logo="Callify" />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
